import React from "react";
import Dict from 'dict-lib';
import {Button, ButtonGroup, ButtonToolbar, Col, Grid, Modal, Row} from 'react-bootstrap';
import ReactDOM from "react-dom";

import stylesScNavbar from './../../dict-components/navbar/ScNavbar.module.css';
import stylesSearchMenu from "../../_css/dictionary/searchMenu.module.css";
import {SCRadiobutton} from "../../dict-components/radiobutton/SCRadiobutton";
import {LexemeUtilities} from "../../lexeme/page/editor/LexemeHelper";
import {AdministrationUtilities} from "../../administration/AdministrationHelper";


export class LexemeGenerator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: true,
            monitoring: false,
            lexemeGeneratorInfos: {status: 'RECUPERO STATUS'},
            erroneousPages: [],
            langsResetStatic: 'ALL',
            resetStaticActions: [],
            langAlphabet: {label: 'scegli una lingua', value: '', selected: [], count: ''},
            optimizing: false,
            optimizeMessage: null,
            checkingPending: false,
            pendingResult: null,
            pollingSettings: null,
            connectivityCheck: null,
            checkingConnectivity: false
        };

        this.intervalPages = null;
        this.intervalErrors = null;
        this.currentPollDelay = null;

        this._getLexemeGeneratorInfos = this._getLexemeGeneratorInfos.bind(this);
        this._startStop = this._startStop.bind(this);
    }

    componentDidMount() {
        this._firstCheck();
        Dict.call('admin/getPollingSettings').then((result) => {
            if (result && result.items) this.setState({pollingSettings: result});
        });
    }

    _firstCheck() {
        this._getLexemeGeneratorInfos();
        this._startCheck();
    }

    _startCheck(delay) {
        const d = delay || 1000;
        // Riavvia l'intervallo solo se il delay è cambiato o non era attivo
        if (this.currentPollDelay === d && this.intervalPages) return;
        clearInterval(this.intervalPages);
        this.currentPollDelay = d;
        this.setState({monitoring: true});
        this.intervalPages = setInterval(() => {
            this._getLexemeGeneratorInfos();
        }, d);
    }

    _stopCheck() {
        clearInterval(this.intervalPages);
        this.intervalPages = null;
        this.currentPollDelay = null;
        this.setState({monitoring: false});
    }

    _close() {
        this.setState({show: false}, () => {
            this._stopCheck();
            setTimeout(function () {
                ReactDOM.unmountComponentAtNode(document.getElementById("dict-modal-container"));
            }, 200);
        });
    }

    _startStop(toStart) {
        if (toStart) {
            this.setState({pendingResult: null});
            Dict.call('dict-api/lexemeGenerator/start/').then(() => {
                Dict.call('dict-api/lexemeGenerator/resetWorkerErrors/').catch(() => {});
                this._startCheck();
            }).catch(() => {
                const lexemeGeneratorInfos = {status: 'Il servizio di staticizzazione non sembra attivo'};
                this.setState({lexemeGeneratorInfos});
            });
        } else {
            Dict.call('dict-api/lexemeGenerator/stop/').then(() => {
                this._stopCheck();
                setTimeout(() => this._getLexemeGeneratorInfos(), 1000);
            }).catch(() => {
                const lexemeGeneratorInfos = {status: 'Il servizio di staticizzazione non sembra attivo'};
                this.setState({lexemeGeneratorInfos});
            });
        }
    }

    _resetOrUptodate(action, label) {
        this._stopCheck();
        var service = action === 'RESET' ? 'resetLexemePages' : 'setLexemePagersUpToDate';
        var actionText = '- hai impostato' + '<span style="margin-left:2px;margin-right:2px;font-weight:bold">' + label + "</span>" + (action === 'RESET' ? 'da staticizzare' : 'già staticizzato');
        Dict.call('concurrentServices/' + service + '/' + this.state.langsResetStatic + '/').then((result) => {
            // Aspetta 4s per garantire che la cache Java (TTL 3s) sia scaduta
            setTimeout(() => this._getLexemeGeneratorInfos(), 4000);
            var resetStaticActions = this.state.resetStaticActions;
            if (label.indexOf('tutti') >= 0) {
                resetStaticActions = [];
            } else {
                resetStaticActions.push(actionText);
            }

            this.setState({resetStaticActions});
        })
    }

    _resetWorkerErrors() {
        Dict.call('dict-api/lexemeGenerator/resetWorkerErrors/').then((result) => {
            const lexemeGeneratorInfos = result.lexemeGeneratorInfos;
            if (lexemeGeneratorInfos) this.setState({lexemeGeneratorInfos});
            else this._getLexemeGeneratorInfos();
        }).catch(() => {
            this._getLexemeGeneratorInfos();
        });
    }

    _resetStatus() {
        Dict.call('dict-api/lexemeGenerator/resetStatus/').then((result) => {
            const lexemeGeneratorInfos = result.lexemeGeneratorInfos;
            if (lexemeGeneratorInfos) this.setState({lexemeGeneratorInfos});
            else this._getLexemeGeneratorInfos();
        }).catch(() => {
            this._getLexemeGeneratorInfos();
        });
    }

    _optimizeSolr() {
        this.setState({optimizing: true, optimizeMessage: null});
        Dict.call('dict-api/lexemeGenerator/optimizeSolr/').then((result) => {
            this.setState({
                optimizing: false,
                optimizeMessage: result && result.message ? result.message : 'Optimize completato'
            });
        }).catch(() => {
            this.setState({optimizing: false, optimizeMessage: 'Errore durante l\'optimize Solr'});
        });
    }

    _resetErrors() {
        Dict.call('dict-api/lexemeGenerator/resetErrors/').then((result) => {
            const lexemeGeneratorInfos = result.lexemeGeneratorInfos;
            if (lexemeGeneratorInfos) this.setState({lexemeGeneratorInfos});
            else this._getLexemeGeneratorInfos();
        }).catch(() => {
            this._getLexemeGeneratorInfos();
        });
    }

    _retryErrors() {
        Dict.call('dict-api/lexemeGenerator/retryErrors/').then((result) => {
            const lexemeGeneratorInfos = result.lexemeGeneratorInfos;
            if (lexemeGeneratorInfos) this.setState({lexemeGeneratorInfos});
            else this._getLexemeGeneratorInfos();
        }).catch(() => {
            this._getLexemeGeneratorInfos();
        });
    }

    _resetStatusInfo() {
        //Dict.call('concurrentServices/resetStatusInfo/').then((result) => {
        //})
    }

    _rebuildIndex() {
        Dict.call('concurrentServices/rebuildIndex/').then((result) => {
            if (result !== 'OK') {
                LexemeUtilities.showErrorModalMessage(result, 5000);
            }
        })
    }

    _checkConnectivity() {
        this.setState({checkingConnectivity: true, connectivityCheck: null});
        const javaHost = encodeURIComponent(Dict.getApiHost());
        Dict.call('admin/checkPollingConnectivity?javaHost=' + javaHost).then((result) => {
            this.setState({connectivityCheck: result, checkingConnectivity: false});
        }).catch(() => {
            this.setState({checkingConnectivity: false});
        });
    }

    _checkPending() {
    this.setState({checkingPending: true, pendingResult: null});
    Dict.call('dict-api/lexemeGenerator/checkPending/').then((result) => {
        const pending = result && result.pending != null ? result.pending : null;
        this.setState({checkingPending: false, pendingResult: pending});
        if (pending === 0) {
            setTimeout(() => this.setState({pendingResult: null}), 3500);
        }
    }).catch(() => {
        this.setState({checkingPending: false, pendingResult: null});
    });
}

    _getLexemeGeneratorInfos() {
        Dict.call('dict-api/lexemeGenerator/status/').then((result) => {
            const lexemeGeneratorInfos = (result && result.lexemeGeneratorInfos) ? result.lexemeGeneratorInfos : {status: 'Il servizio di polling non sembra attivo'};
            const isRunning = lexemeGeneratorInfos.status === 'RUNNING';
            const pollDelay = isRunning ? 2000 : 1000;
            this.setState({lexemeGeneratorInfos}, () => {
                if (isRunning && !this.state.monitoring) {
                    this._startCheck(pollDelay);
                } else if (this.state.monitoring) {
                    // Aggiusta l'intervallo se lo status è cambiato (RUNNING ↔ altro)
                    this._startCheck(pollDelay);
                }
            });
        }).catch(() => {
            const lexemeGeneratorInfos = {status: 'Il servizio di staticizzazione non sembra attivo'};
            this.setState({lexemeGeneratorInfos});
        });
    }

    render() {
        const infos = this.state.lexemeGeneratorInfos || {status: 'Il servizio di polling non sembra attivo'};
        const erroneousPages = this.state.erroneousPages;
        const retrievingData = infos.status === 'RECUPERO STATUS';
        const serviceNotActive = infos.status === 'Il servizio di polling non sembra attivo';
        const remaining = infos.remaining != null ? infos.remaining : null;
        const isFinished = infos.status === 'COMPLETE';
        const isStop = infos.status === 'STOP' || infos.status === 'JAVA_UNREACHABLE' || serviceNotActive || isFinished;
        const isCompleted = isStop && remaining === 0 && remaining != null;
        const currentOrigin = window.location.protocol + '//' + window.location.hostname;
        const javaHostDisplay = infos.java_host ? infos.java_host.replace(/:\d+$/, '') : '';
        const startedByOther = false; // TODO: da riabilitare quando il confronto host sarà risolto
        const {optimizing, optimizeMessage, checkingPending, pendingResult} = this.state;
        const hasPending = pendingResult != null && pendingResult > 0;
        const checkedNoPending = pendingResult != null && pendingResult === 0;

        var productionButton = '';
        /*if (process.env.NODE_ENV === 'development') {
            productionButton = <Button onClick={() => this._rebuildIndex()}>ricostruisci indice</Button>;
        }*/

        var langsResetStaticCollection = [];
        langsResetStaticCollection.push({label: 'tutti i lessemi', code: 'ALL'});
        var langsResetStatictCollectionToAdd = Dict.getVarious('root_languages').filter((langItem) => {
            return langItem.is_active === true;
        }).map((item) => {
            return {label: item.label, code: item.id + ''};
        });
        langsResetStaticCollection = langsResetStaticCollection.concat(langsResetStatictCollectionToAdd);
        var selectedLangLabel = langsResetStaticCollection.find((item) => {
            return item.code === this.state.langsResetStatic
        }).label;
        const elSelectedLabel = <span style={{marginLeft: '2px', fontWeight: 'bold'}}>{selectedLangLabel}</span>;

        return <Modal show={this.state.show} dialogClassName={stylesScNavbar['lexeme-pages-generator-dialog-modal']}
                      restoreFocus onHide={() => { if (!optimizing) this._close(); }}>
            <Modal.Header closeButton={!optimizing}><h4 className={'modal-title'}>Generazione dei lessemi</h4></Modal.Header>
            <Modal.Body>
                {optimizing && <div style={{textAlign:'center', padding:'20px', fontWeight:'bold', color:'#31708f', backgroundColor:'#d9edf7', borderRadius:'4px', marginBottom:'10px'}}>
                    ⏳ Ottimizzazione Solr in corso... attendere prego
                </div>}
                {optimizeMessage && !optimizing && <div style={{textAlign:'center', padding:'10px', fontWeight:'bold', color:'#3c763d', backgroundColor:'#dff0d8', borderRadius:'4px', marginBottom:'10px'}}>
                    ✓ {optimizeMessage}
                </div>}
                {hasPending && <div style={{textAlign:'center', padding:'10px', fontWeight:'bold', color:'#8a6d3b', backgroundColor:'#fcf8e3', borderRadius:'4px', marginBottom:'10px'}}>
                    ⚠ Ci sono <strong>{pendingResult}</strong> lessemi da staticizzare
                </div>}
                {checkedNoPending && <div style={{textAlign:'center', padding:'10px', fontWeight:'bold', color:'#3c763d', backgroundColor:'#dff0d8', borderRadius:'4px', marginBottom:'10px'}}>
                    ✓ Nessun nuovo lessema da staticizzare
                </div>}
                {this.state.pollingSettings && (() => {
                    const ps = this.state.pollingSettings;
                    const {connectivityCheck, checkingConnectivity} = this.state;
                    const getVal = (key) => (ps.items.find(i => i.key === key) || {}).value || '';
                    const pollingUrl = getVal('dict.lexeme.generator.polling.url') || 'http://localhost:5000 (default)';
                    const javaHost = getVal('dict.lexeme.generator.java.host') || Dict.getApiHost();
                    const translator = getVal('dict.external-translator');
                    const apiKeyVal = getVal('dict.batch.api-key');
                    const translatorWarning = ps.items.find(i => i.key === 'dict.external-translator' && i.warning);

                    const statusIcon = (check) => {
                        if (!check) return null;
                        if (check.status === 'ok') return <span style={{color:'#3c763d'}}> ✓</span>;
                        if (check.status === 'skipped') return <span style={{color:'#3c763d'}}> ✓ <span style={{color:'#888', fontStyle:'italic'}}>(auto)</span></span>;
                        return <span style={{color:'#a94442'}}> ✗ {check.message || ('HTTP ' + check.httpCode)}</span>;
                    };

                    return <>
                        <Row style={{fontSize: '11px', color: '#555', backgroundColor: '#f5f5f5', padding: '6px 10px', borderRadius: '4px', marginBottom: '4px', marginLeft: '0', marginRight: '0'}}>
                            <span style={{marginRight: '16px'}}><strong>Python polling server:</strong> {pollingUrl}{connectivityCheck && statusIcon(connectivityCheck.flask)}</span>
                            <span style={{marginRight: '16px'}}><strong>Java host:</strong> {javaHost}{connectivityCheck && statusIcon(connectivityCheck.javaHost)}</span>
                            <span style={{marginRight: '16px', color: translatorWarning ? '#a94442' : 'inherit'}}>
                                <strong>Traduttore:</strong> {translator || <em style={{color:'#a94442'}}>⚠ non configurato</em>}
                            </span>
                            <span style={{marginRight: '16px'}}><strong>API key:</strong> {apiKeyVal ? <span style={{color:'#3c763d'}}>✓ {apiKeyVal}</span> : <span style={{color:'#a94442'}}>✗ assente</span>}{connectivityCheck && statusIcon(connectivityCheck.apiKey)}</span>
                            <Button bsSize="xsmall" disabled={checkingConnectivity}
                                    onClick={() => this._checkConnectivity()}>
                                {checkingConnectivity ? '...' : 'testa connessione'}
                            </Button>
                        </Row>
                    </>;
                })()}
                <Row>
                    <ButtonToolbar>
                        <ButtonGroup className={stylesScNavbar['lexeme-pages-generator-buttongroup-modal']}>
                            {startedByOther ?
                                <Button disabled={optimizing} onClick={() => this.state.monitoring ? this._stopCheck() : this._startCheck()}>
                                    {this.state.monitoring ? 'stop monitoraggio' : 'avvia monitoraggio'}
                                </Button>
                            : <>
                                <Button disabled={optimizing} onClick={() => this._startStop(isStop)}
                                        style={{visibility: ((isCompleted && !hasPending) || retrievingData ? 'hidden' : 'visible')}}>{isStop ? 'avvia staticizzazione' : 'ferma staticizzazione'}</Button>
                                {isCompleted &&
                                    <Button disabled={optimizing || checkingPending} bsStyle="default"
                                            onClick={() => this._checkPending()}>
                                        {checkingPending ? 'controllo...' : 'controlla nuovi lessemi'}
                                    </Button>
                                }
                                {isStop && <>
                                    <Button disabled={optimizing} className={stylesScNavbar['lexeme-pages-generator-dynamic-button']}
                                            onClick={() => this._resetOrUptodate('RESET', selectedLangLabel)}>imposta {elSelectedLabel} da
                                        staticizzare</Button>
                                    <Button disabled={optimizing} className={stylesScNavbar['lexeme-pages-generator-dynamic-button']}
                                            onClick={() => this._resetOrUptodate('UPTODATE', selectedLangLabel)}>imposta {elSelectedLabel} già
                                        staticizzato/i</Button>
                                    <Button disabled={optimizing} onClick={() => this._resetErrors()}>reset errori</Button>
                                    {infos.errors > 0 &&
                                        <Button disabled={optimizing} bsStyle="warning" onClick={() => this._retryErrors()}>riprova errori ({infos.errors})</Button>
                                    }
                                    {!optimizing &&
                                        <Button bsStyle="info" onClick={() => this._optimizeSolr()}>ottimizza indice Solr</Button>
                                    }
                                    {optimizing &&
                                        <Button bsStyle="info" disabled>ottimizzazione in corso...</Button>
                                    }
                                </>}
                                {infos.status === 'JAVA_UNREACHABLE' &&
                                    <Button disabled={optimizing} bsStyle="warning" onClick={() => this._resetStatus()}>ripristina stato (Java irraggiungibile)</Button>
                                }
                                {productionButton}
                            </>}
                        </ButtonGroup>
                    </ButtonToolbar>
                </Row>
                <Grid>
                    <Row className={stylesScNavbar['lexeme-pages-generator-status-modal']}>
                        Monitoraggio: <strong style={{marginRight: '10px'}}>{this.state.monitoring ? 'ATTIVO' : 'NON ATTIVO'}</strong>
                        Stato: <strong>{infos.status + (isCompleted ? '/COMPLETE' : '')}</strong>
                        {startedByOther && <span style={{marginLeft: '15px', color: '#888'}}>avviato da: <strong>{javaHostDisplay || 'host sconosciuto'}</strong></span>}
                    </Row>
                    {Object.keys(infos).length > 0 && !retrievingData && !serviceNotActive ?
                        <Row className={stylesScNavbar['lexeme-pages-generator-row-cols-modal']}>
                            <Col lg={3}
                                 md={3}>{isCompleted && !hasPending ? 'Elaborazione completa' : 'Lemmi da processare: '}<strong>{isCompleted && hasPending ? pendingResult + ' / ' + (infos.totEntries || '?') : !isCompleted && remaining != null ? remaining + ' / ' + (infos.totEntries || '?') : ''}</strong>
                            </Col>
                            <Col lg={9} md={9} style={{visibility: (!isStop ? 'visible' : 'hidden')}}>Lemma
                                corrente: <strong>{typeof infos.currentLexemePage === 'undefined' ? '' : infos.currentLexemePage.label}</strong>
                            </Col>
                        </Row> : ''}
                    {this.state.lexemeGeneratorInfos.status === 'STOP' ? <><SCRadiobutton key={"key-radio-languages"}
                                                                                          bsStyle="primary"
                                                                                          id={'dict-languages'}
                                                                                          items={langsResetStaticCollection}
                                                                                          additionalClass={stylesSearchMenu['dict-languages-radio']}
                                                                                          default={this.state.langsResetStatic}
                                                                                          callbackParent={(langsResetStatic) => {
                                                                                              this.setState({langsResetStatic});
                                                                                          }}/>
                        <Row style={{marginTop: '5px'}}>
                            <div dangerouslySetInnerHTML={{__html: this.state.resetStaticActions.join('<br>')}}/>
                        </Row></> : ''}
                </Grid>
            </Modal.Body>
            {Object.keys(infos).length > 0 && !retrievingData && !serviceNotActive ?
                <Modal.Footer>
                    <span>Errori trovati: <strong>{infos.errors}</strong></span>
                    {infos.workerErrors > 0 ?
                        <span style={{marginLeft: '15px', color: 'red'}}>
                            Errori comunicazione Polling→Java: <strong>{infos.workerErrors}</strong>
                        </span> : ''}
                </Modal.Footer> : ''}
        </Modal>;
    }
}